import { Location } from '../../components/NewSearch/NewSearchLocations/types';

export const getUpdatedChosenLocationIds = (
  group: Location[],
  isSelected: boolean,
  chosenLocationIds: string[]
): string[] => {
  const chosenIdsSet = new Set(chosenLocationIds);

  if (isSelected) {
    group.forEach(location => chosenIdsSet.add(location.id));
  } else {
    group.forEach(location => chosenIdsSet.delete(location.id));
  }

  return Array.from(chosenIdsSet);
};
